import { Component } from '@angular/core';

@Component({
  selector: 'tart-fake-backdrop',
  template: ``,
})
export class FakeBackdropComponent {
  constructor() { }
}
